//  Foursquare API keys:
export const CLIENT_ID = '33LPKXSAQYPD5ENO5TANMFDO0Q1KJKP2CD4YAEPPNCP31YCW';
export const CLIENT_SECRET = 'HVWNE3T4IDMORFOMT2MY02FMULEFRWIWGFTAXQVKU134E3QX';

//   Google Maps API key
export const MAP_KEY = 'AIzaSyCsVZYthhu4Ph4DPgr8RqN8Uxygrg1l7ro';


